import script from "./UiTabs2.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTabs2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__